import { MetaMaskConnector } from '@wagmi/core/connectors/metaMask'

export function buildMetaMaskConnector(chains): MetaMaskConnector {
  return new MetaMaskConnector({
    chains,
  })
}
